import { render } from "./Headline.vue?vue&type=template&id=50de1e1f&scoped=true"
import script from "./Headline.vue?vue&type=script&lang=js"
export * from "./Headline.vue?vue&type=script&lang=js"

import "./Headline.vue?vue&type=style&index=0&id=50de1e1f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50de1e1f"]])

export default __exports__